import { Box, Link, Stack, Typography, useTheme } from '@mui/material';
import { useDictionary, useIsDesktop } from 'Hooks';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useNavigate } from 'react-router-dom';
import { DynamicArrow } from 'Components/DynamicArrow';
import { RepAlert } from 'Components/RepAlert';
import { getIsLawyer, getIsLawyerAndUser } from 'Utils/lawyers';

interface ILinkReturnToMain {
  link?: string;
  label?: string;
  internal?: boolean;
  color?: string;
  onClick?: () => void; // overrides link
  tabIndex?: number;
}

export const LinkReturnToMain = (props: ILinkReturnToMain) => {
  const generalDictionary = useDictionary(Dictionary, DICTIONARY.General);
  const navigate = useNavigate();
  const palette = useTheme().palette;
  const isDesktop = useIsDesktop();

  const isLawyer = getIsLawyerAndUser()
    ? sessionStorage.getItem('isLawyer') === 'true'
    : getIsLawyer();

  return (
    <>
      {isLawyer && <RepAlert />}
      <Link
        tabIndex={props.tabIndex || 0}
        href={
          props.onClick || isLawyer
            ? undefined
            : !props.internal
            ? props.link
              ? props.link
              : import.meta.env.VITE_APP_REDIRECT_URL
            : undefined
        }
        onClick={() =>
          props.onClick
            ? props.onClick()
            : isLawyer
            ? navigate('/lawyers-lobby')
            : props.internal && props.link && navigate(props.link)
        }
        onKeyDown={(e: React.KeyboardEvent) => {
          if (e.key === 'Enter') {
            if (props.onClick) props.onClick();
            else props.internal && props.link && navigate(props.link);
          }
        }}
        sx={{ textDecoration: 'none', width: 'fit-content' }}
        color={props.color}
        underline={'hover'}
      >
        <Stack direction='row' gap='4px' alignItems='center'>
          <Box pt={isDesktop ? '8px' : '7px'}>
            <DynamicArrow
              color={props.color ?? palette.primary.main}
              rotate={-90}
            />
          </Box>
          <Typography variant='body6'>
            {props.label ? props.label : generalDictionary.returnToMain}
          </Typography>
        </Stack>
      </Link>
    </>
  );
};
